/* Global actions */
export const UPDATE_OUTDATED_STATE = 'global/UPDATE_OUTDATED_STATE';
export const UPDATE_VIEW_TYPE = 'global/UPDATE_VIEW_TYPE';
export const UPDATE_LAST_ROUTE = 'global/UPDATE_LAST_ROUTE';
export const UPDATE_LAST_ATTEMPTED_ROUTE = 'global/UPDATE_LAST_ATTEMPTED_ROUTE';
export const UPDATE_LOAN_TYPE = 'global/UPDATE_LOAN_TYPE';

/* Layout Actions */
export const SET_APP_TITLE = 'layout/SET_APP_TITLE';
export const SET_APP_FOOTER = 'layout/app/SET_APP_FOOTER';

/* Onboarding Form */
export const SET_INITIAL_LOAN_TYPE = 'onboarding/SET_INITIAL_LOAN_TYPE';
export const ONBOARDING_FORM_ERROR = 'onboarding/ONBOARDING_FORM_ERROR';

/* TOS */
const TERMS_NAMESPACE = `termsOfService`;
export const START_FETCH_TOS = `${TERMS_NAMESPACE}/START_FETCH_TOS`;
export const SUCCESS_FETCH_TOS = `${TERMS_NAMESPACE}/SUCCESS_FETCH_TOS`;
export const ERROR_FETCH_TOS = `${TERMS_NAMESPACE}/ERROR_FETCH_TOS`;
export const ACCEPT = `${TERMS_NAMESPACE}/ACCEPT`;

/* EConsent */
const ECONSENT_NAMESPACE = `econsent`;
export const START_FETCH_ECONSENT = `${ECONSENT_NAMESPACE}/START_FETCH_ECONSENT`;
export const SUCCESS_FETCH_ECONSENT = `${ECONSENT_NAMESPACE}/SUCCESS_FETCH_ECONSENT`;
export const ERROR_FETCH_ECONSENT = `${ECONSENT_NAMESPACE}/ERROR_FETCH_ECONSENT`;

/* Privacy Policy */
const PRIVACY_NAMESPACE = `privacyPolicy`;
export const START_FETCH_PRIVACY_POLICY = `${PRIVACY_NAMESPACE}/START_FETCH_PRIVACY_POLICY`;
export const SUCCESS_FETCH_PRIVACY_POLICY = `${PRIVACY_NAMESPACE}/SUCCESS_FETCH_PRIVACY_POLICY`;
export const ERROR_FETCH_PRIVACY_POLICY = `${PRIVACY_NAMESPACE}/ERROR_FETCH_PRIVACY_POLICY`;
